import styled from 'styled-components';

const s = {
  volume: styled.div`
    display: flex;
    align-items: center;
    pointer-events: ${(props) =>
      props.isMobile && !props.isVisible ? 'none !important' : 'all !important'};
    border-radius: 25px;
    background: ${(props) => (props.isMuted ? 'rgb(222, 28, 34)' : '')};
    height: 36px;
    margin-top: 3px;
    @media (min-width: 421px) {
      svg {
        margin: 1px 8px 0 -1px;
      }
    }
  `,

  volumeBarWrapper: styled.div`
    opacity: ${(props) => props.visible};
    overflow: hidden;
    transition: opacity 0.2s linear, width 0.2s linear;
    width: ${(props) => (props.visible ? '120px' : '0')};
    pointer-events: all;
  `,
};

export default s;
